import { render, staticRenderFns } from "./ProductAdoptionTable.vue?vue&type=template&id=324b4a34&scoped=true"
import script from "./ProductAdoptionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAdoptionTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductAdoptionTable.vue?vue&type=style&index=0&id=324b4a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b4a34",
  null
  
)

export default component.exports